module.exports = __webpack_public_path__ + "static/media/ic-3.c1659cc4.svg";